"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isPresent;
var _is_blank = _interopRequireDefault(require("./is_blank"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function isPresent(object) {
  return !(0, _is_blank["default"])(object);
}
;